import { Negotiation, User, ProductReservation, Product, Comment } from '@vestiaire/api-sdk-angular';

export class Discussions {
  public negotiations: Negotiation[];

  getNegoByAuthorId(authorId): Negotiation | null {
    let nego: Negotiation;
    if (this.negotiations) {
      nego = this.negotiations.find(n => n.buyer.id === authorId);
    }

    return nego ? nego : null;
  }
}

export interface IDiscussionModalData {
  allComments: Comment[];
  commentType: string;
  isAuthenticated: boolean;
  product?: Product;
  negotiations: Negotiation[];
  reservation: ProductReservation;
  user: User;
  editoId?: string;
  showLikeFunctionality?: boolean;
}
